module.exports = __webpack_public_path__ + "static/media/Cover.956ca926.jpg";